
import http from './http'
const api = {} 
api.getHeaderData = (params)=>http.get('/website-server/open/listNavigationBars',params) // 查询导航菜单 
api.getContractUs = (params)=>http.get('/website-server/open/listContentByType',params) // 联系我们 
api.checkHomeInfo = (params)=>http.get('/website-server/open/getHomePageMaterialContent',params) // 查询首页素材信息 
api.getHomeMaterialList =(params)=>http.get('/website-server/material/listMaterialByDisplayTypeByTypeOrMenu',params) //查询首页目录排序
api.getDetailMaterialList =(params)=>http.get('/website-server/webMenu/getById',params) //查询素材目录详情
api.getMubeDetailInfo =(params)=>http.get('/website-server/open/listMaterialByMenuAndDisplayType',params) //查询目录获取挂载的素材内容
api.getHomeContentInfo = (params)=>http.get('/website-server/open/getSingleContentByType',params) // 查询文本内容
api.getAboutUsInfo = (params)=>http.get('/website-server/open/getHtmlTextByMaterialTypeId',params) // 通过素材类型id查询唯一的素材富文本 --关于我们
api.getHtmlTextInfo = (params)=>http.get('/website-server/open/getHtmlTextByMaterialId',params) // 获取素材富文本
api.submitLeaveMsg = (params)=>http.post('/website-server/open/addMessage',params) // 提交留言
api.getGoodsInfo = (params)=>http.get('/website-server/open/listRelationMaterialByByMaterialTypeAndDisplayType',params) // 查询分类商品
api.getGoodsList = (params)=>http.get('/website-server/open/listMaterialByMaterialTypeAndDisplayType',params) // 查询商品列表

api.getMubeIdList =(params)=>http.get('/website-server/open/listMaterialTypeByMenuAndDisplayType',params) //通过目录查询挂载的素材类别列表
api.getMaterialIdInfo =(params)=>http.get('/website-server/open/getMaterialByMaterialId',params) //通过素材id获取素材内容 
api.getMaterialTypeIdInfo =(params)=>http.get('/website-server/open/getMaterialTypeByParentMaterialType',params) //通过父素材类别id查询所有的子素材类别
api.getDeviceWarnInfo =(params)=>http.get('/website-server/open/getSystemStatisticsData',params) //清渟云网预警，监测数信息
api.getRecruitmentInfo =(params)=>http.get('/website-server/open/getRecruitmentInfo',params) //招贤纳士 

api.getMaterialMenu =(params)=>http.get('/website-server/material/listByTypeOrMenu',params) // 查询政府成功案例
api.reqLoginNoPwd =(params)=>http.post('/authentication-server/business/loginByPhoneCode',params) // 查询政府成功案例



export default api



// WEBPACK FOOTER //
// ./src/api/newApi.js